import EmbedCSL from "@/components/EmbedCSL";

const CSLEmbed = () => {
  // Get URL parameters for customization
  const urlParams = new URLSearchParams(window.location.search);
  const compact = urlParams.get('compact') === 'true';
  const showHero = urlParams.get('hero') !== 'false';
  const showQuickFacts = urlParams.get('facts') !== 'false';
  const showLearningAreas = urlParams.get('learning') !== 'false';
  const showRequirements = urlParams.get('requirements') !== 'false';
  const showBenefits = urlParams.get('benefits') !== 'false';
  const showIdealFor = urlParams.get('ideal') !== 'false';
  const showNextSteps = urlParams.get('steps') !== 'false';
  const maxWidth = urlParams.get('width') || '6xl';

  return (
    <EmbedCSL 
      compact={compact}
      showHero={showHero}
      showQuickFacts={showQuickFacts}
      showLearningAreas={showLearningAreas}
      showRequirements={showRequirements}
      showBenefits={showBenefits}
      showIdealFor={showIdealFor}
      showNextSteps={showNextSteps}
      maxWidth={maxWidth}
    />
  );
};

export default CSLEmbed;